var noop = function (_) { };
/**
 * Repeatedly call fn, while test returns true. Calls callback when stopped, or an error occurs.
 *
 * @param {Function} test Synchronous truth test to perform before each execution of fn.
 * @param {Function} iterator A function which is called each time test passes. The function is passed a callback(err), which must be called once it has completed with an optional err argument.
 * @param {Function} callback A callback which is called after the test fails and repeated execution of fn has stopped.
 */
export default function whilst(test, iterator, callback) {
    if (callback === void 0) { callback = noop; }
    if (test()) {
        iterator(function next(err) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (err) {
                callback(err);
            }
            else if (test.apply(this, args)) {
                iterator(next);
            }
            else {
                callback(null);
            }
        });
    }
    else {
        callback(null);
    }
}
//# sourceMappingURL=whilst.js.map